import SuperJSON from "superjson";
import Id from "../types/Id";

export default class ResourceId extends Id<"resource"> {}

SuperJSON.registerClass(ResourceId);
